import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        workstreams: store.workstreams
    };
})

class Member extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { member, dispatch, workstreams } = this.props;
        const taskCountActive = (member.assigneeIn?.length + member.reviewerIn?.length + member.approverIn?.length) || 0;

        if (!workstreams.selected.id) {
            return null;
        }

        const handleReassign = () => {
            dispatch({ type: "UPDATE_WORKSTREAMS_SELECTED_MEMBER", member: member });
            $("#reassignTask").modal("show");
        }

        const handleRemove = () => {
            dispatch({type: "UPDATE_WORKSTREAMS_SELECTED", selected: { 
                ...workstreams.selected, 
                members: workstreams.selected.members.map(m => {
                    if(m.id === member.id) {
                        return {...m, isSelected: true}
                    }

                    return {...m, isSelected: false};
                })
            }});

            $(`#removeUser`).modal("show");
        }

        const handleMakeLead = () => {
            dispatch({
                type: "UPDATE_WORKSTREAMS_SELECTED", 
                selected: {
                    ...workstreams.selected, 
                    lead: member,
                    members: workstreams.selected.members.map(m => {
                        if(m.id === member.id) {
                            return {
                                ...m, 
                                assign: "responsible", 
                                isNewLead: true
                            }
                        }

                        return {
                            ...m, 
                            assign: "assignedTo", 
                            isNewLead: false
                        }
                    }), 
                }
            });
        }

        const canBeLead = () => {
            return member.role === "Internal Admin" || member.role === "Internal Manager" || member.role === "Internal Master Admin" ;
        }

        const isWorkstreamLead = member.id === workstreams.selected.lead.id;

        return (
            <div class={`memberItem ${member.assign !== "responsible" && member.isRemoved ? "removed" : ""}`}>
                <div class="memberDetails">
                    <div class="memberAvatar">
                        <Avatar name={`${member.fullName}`} disableTooltip={true} image={member.avatar !== "default.png" ? `${this.props.avatarBaseUrl}${member.avatar}` : null} />
                    </div>
                    <div class="memberContent">
                        <p>{`${member.fullName}`} - <span>{ `${taskCountActive} assigned task/s`}</span></p>
                        <div class="memberRole">
                            <p>{member.role}</p>
                        </div>
                        <div class="memberStatus">
                            {isWorkstreamLead && <div class={`statusChip workstreamLead`}>Workstream Lead</div>}
                            {canBeLead() && !isWorkstreamLead && !member.isRemoved && (
                                <div class={`statusChip`}>
                                    <a onClick={handleMakeLead}>Make Lead</a>
                                </div>
                            )}
                            {member.isNew && <div class={`statusChip new`}>New!</div>}
                        </div>
                    </div>
                </div>
                <div class="memberActions">
                    {/* {member.assign === "responsible" && <button type="button" class="btn btnAssign" onClick={handleReassign}>Re-assign</button>} */}
                    <button type="button" class={`btn btnAssign ${taskCountActive > 0 ? "" : "disabled"}`} onClick={handleReassign}>Re-assign task/s</button>
                    {!isWorkstreamLead && !member.isRemoved && <button type="button" class="btn btnRemove" onClick={handleRemove}>Remove Member</button>}
                    {!isWorkstreamLead && member.isRemoved && <button type="button" class="btn" onClick={handleRemove}>Removed</button>}
                </div>
            </div>
        );
    }
}

export default Member;
